<form nz-form *ngIf="mainformGroup" [formGroup]="mainformGroup" [nzLayout]="'vertical'">

    <div *ngIf="editMode" class="edit-panel">
        <div class="edit-panel-action">
            <button nz-button nzSize="small" nzType="primary" (click)="saveRow()" class="search-button">{{'save'|translateTA}}</button>
            <button nz-button nzSize="small" (click)="clearRow()" class="search-button">{{'reset'|translateTA}}</button>
            <button nz-button nzSize="small" nzDanger (click)="editMode=false;clearRow();">{{'cancel'|translateTA}}</button>
        </div>
        <!--nz-divider *ngIf="INTERNALID== null || INTERNALID==''" nzText="{{'workflow.new.variable'|translateTA}}" nzOrientation="right"></nz-divider>
        <nz-divider *ngIf="INTERNALID!= null && INTERNALID!=''" nzText="{{'workflow.edit.variable'|translateTA:{internalid:INTERNALID} }}" nzOrientation="right"></nz-divider-->
        <div class="edit-panel-container">
            <div nz-row *ngFor="let row of formRows" [nzGutter]="16">
                <nz-col *ngFor="let item of field.tableConfiguration.fields|arrayFilter:'row':row?.toString():false" [nzSpan]="item.colSpan" [nzOrder]="field.col">
                    <webhook-common [mainformGroup]="newRow" [field]="item" [variables]="variables"  [configuration]="configuration"  [rootForm]="newRow" > </webhook-common>
                </nz-col>
            </div>
        </div>        
    </div>
    <div class="edit-panel-action" *ngIf="!editMode" >
        <button nz-button nzType="primary" nzShape="circle" (click)="addNewRow()">
        <nz-icon nzType="plus" />
        </button>
    </div>
    <div class="edit-panel-container" *ngIf="!editMode" >
        <nz-table  *ngIf="!field.hidden"
                [nzPaginationType]="'small'"
                [nzShowPagination]="field.tableConfiguration.showPagination==null? true : field.tableConfiguration.showPagination"
                [nzSize]="field.tableConfiguration.size==null? 'small' : field.tableConfiguration.size"
                [nzPageSize]="pageSize"
                [nzPageIndex]="pageIndex"
                [nzFrontPagination]="false" 
                [nzData]="pagedRows" 
                [nzBordered]="true" 
                [nzTotal]="rows.length"
                [nzTableLayout]="field.tableConfiguration.layout!=null?field.tableConfiguration.layout:'fixed'"
                [nzScroll]="field.tableConfiguration.scroll!=null?field.tableConfiguration.scroll:{x:null,y:null}"
                (nzPageIndexChange)="pageIndex = $event">
            <thead>
            <tr>
                <ng-container  *ngFor="let item of field.tableConfiguration.fields">
                    <th class="cell-normal" *ngIf="item.gridConfig==null|| !item.gridConfig.noShow" [colSpan]="item.gridConfig==null||item.gridConfig.colSpan==null?1:item.gridConfig.colSpan">{{item.label|translateTA}}</th>
                </ng-container>
                <th colSpan="1" *ngIf="showAction">{{'action'|translateTA}}</th>
            </tr>
            </thead>
            <tbody [formArrayName]="fieldNew">
                <tr *ngFor="let row of pagedRows; let i = index" [formGroupName]="(pageIndex - 1) * pageSize + i" (dblclick)="editRow(i)">
                     @let rowindex = (pageIndex - 1) * pageSize + i;
                    <ng-container  *ngFor="let item of field.tableConfiguration.fields">
                        <td class="cell-normal" *ngIf="item.gridConfig==null|| !item.gridConfig.noShow" [colSpan]="item.gridConfig==null||item.gridConfig.colSpan==null?1:item.gridConfig.colSpan">
                            <!--webhook-common [mainformGroup]="rows.at(i)" [field]="item" [variables]="variables"  [configuration]="this.configuration" [rootForm]="rows.at(i)"> </webhook-common--> 
                            <div>{{rows.at(rowindex).get(item.field)?.value}}</div>
                        </td>
                    </ng-container>
                    <td colSpan="1" *ngIf="showRemove">
                        <button nz-button nzType="primary" nzShape="circle"  (click)="editRow(rowindex)" class="search-button">
                            <nz-icon nzType="edit" />
                        </button>
                        <button nz-button  nzType="primary" style="color: #ccecb8;" nzShape="circle" (click)="removeRow(rowindex)">
                            <nz-icon nzType="delete" style="color: #ccecb8;" />
                        </button>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</form>

